import { PropsWithChildren, useMemo } from 'react';

import { ChatRootProvider, ChatRootProviderProps } from '@aicon-dev/caas-chat';
import { useTranslation } from 'react-i18next';

import { useLocale } from '~/libs/hooks/useLocale';
import { useAuthContext } from '~/modules/auth/context/AuthProvider';

export const ChatAppProvider = (props: PropsWithChildren<unknown>) => {
  const { children } = props;
  const { token, userInfo } = useAuthContext();
  const { locale } = useLocale();
  const { t, i18n } = useTranslation('project_chat');

  const chatLocale: ChatRootProviderProps['locale'] = useMemo(() => {
    const resources = i18n.getResourceBundle(i18n.resolvedLanguage || 'en', 'project_chat') || {};
    return {
      dayjsLocale: locale,
      ...resources,
    };
  }, [t, i18n, locale, i18n.resolvedLanguage]);

  return (
    <ChatRootProvider
      appId={process.env.REACT_APP_SENDBIRD_APP_ID || ''}
      userId={userInfo?._id || ''}
      caasApiUrl={process.env.REACT_APP_API_SERVER || ''}
      caasAuthToken={token || ''}
      language={locale}
      locale={chatLocale}
      froalaEditorKey={import.meta.env.REACT_APP_FROALA_EDITOR_KEY}
    >
      {children}
    </ChatRootProvider>
  );
};
